import { Button } from '@material-ui/core';
import en from '../../../../lang/en-us';
import { connect } from 'react-redux';
import { RootStateType } from '../../../../redux-store/reducers';
import { getPortfolio } from '../../../../redux-store/actions/portfolio';
import { useEffect, useState } from 'react';
import { RowInfoType } from '../ChangeEmail/change-email-list';
import {
    getPortfoliosFilteredData,
    portfoliosByMinorStatus,
    portfoliosByModeOfHolding,
    portfoliosByTransactionResource,
} from '../../portfolios/utils';
import { sendPhoneOTP } from '../../../../redux-store/actions/nct';
import { NoteModals } from '../../../../lib/NoteModals';
import { maskMobileNumber } from '../../../../utils/utilityFunctions';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import {
    UPDATE_MOBILE,
    OTP_ACTIONS,
    REGISTER_WITH_MOBILE,
    REGISTER_WITH_EMAIL,
    addDialCode,
} from '../../../../utils/constants';
import NoFoliosFound from '../NoFoliosFound';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { ActionHeader, FaqLink } from '..';
import { emailRegisteredUser, nextScreen } from './flow';
import { NFT_TRXN_TYPE_MAP } from '../../commercial/utils';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';

const { dashboard } = en;

const columns: TableColumn[] = [
    { field: 'id', headerName: 'Folio' },
    { field: 'amcName', headerName: 'Fund House', width: 350 },
    { field: 'investorName', headerName: 'Primary Holder', width: 290 },
    {
        field: 'mobile',
        headerName: 'Mobile Number',
        width: 200,
        valueGetter: ({ row, ...params }) => maskMobileNumber(row?.mobile),
    },
];

function ChangeMobile(props: any) {
    const [rowData, setRowData] = useState<RowInfoType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { tableRows, tableColumns, selectedRows, setSelectedRows } = useTableWithCollapse<
        RowInfoType[]
    >({ rows: rowData, columns, loading });
    const [show, setShow] = useState<boolean>(false);
    const { mobile: newMobile } = props.location.state || {};
    const handleSubmit = async () => {
        const {
            pan = '',
            pekrn = '',
            mobile = '',
            email = '',
            action = OTP_ACTIONS.changeMobile,
        } = props;
        const goTo = nextScreen(props.match.path);
        const foliosToUpdate = selectedRows.filter(
            (fund) => addDialCode(fund.mobile) !== addDialCode(newMobile),
        );
        if (foliosToUpdate.length) {
            try {
                // const action = emailRegisteredUser()
                //     ? OTP_ACTIONS.changeEmail
                //     : OTP_ACTIONS.changeMobile;
                let res = await props.sendPhoneOTP({
                    mobile,
                    pan,
                    pekrn,
                    email,
                    action: OTP_ACTIONS.changeMobile,
                });
                props.history.push(goTo, {
                    mobile: props.mobile,
                    pan: props.pan,
                    ...(props?.location?.state || {}),
                    foliosToUpdate,
                    action,
                    ...(res || {}).body,
                });
            } catch (err: any) {
                alert(err.message);
            }
        }
    };
    // Avoid direct navigation to this page if user is registered through email
    const { userRegisteredWith } = props || {};
    useEffect(() => {
        // This page should not be opened by entering the url if registered with Email
        // This page is the first page in the flow, if user is registered with mobile number.
        // But this page comes as 3rd page in the flow when user is email registered
        if (userRegisteredWith == REGISTER_WITH_EMAIL) {
            if (!props.location.state) {
                props.history.replace('/');
                return;
            }
        }
    }, []);

    useEffect(() => {
        async function fetchPortfolio() {
            try {
                setLoading(true);
                const { pan = '', pekrn = '', mobile = '', reqId = '' } = props;
                await props.getPortfolio({
                    pan,
                    pekrn,
                    mobile,
                    reqId,
                });
                setLoading(false);
            } catch (err: any) {
                alert(err.message);
                setLoading(false);
            }
        }
        fetchPortfolio();
    }, []);

    useEffect(() => {
        const { portfolios = {} } = props;
        const { data: folioList = [] } = portfolios;
        const filters: Function[] = [
            portfoliosByTransactionResource,
            portfoliosByMinorStatus,
            portfoliosByModeOfHolding,
        ];
        let data: RowInfoType[] = getPortfoliosFilteredData(folioList, filters);
        const { activeFunds = [], disabledFunds = [] } = data.reduce((prev: any, curr: any) => {
            if (addDialCode(curr.mobile) !== addDialCode(newMobile)) {
                return {
                    ...prev,
                    activeFunds: [...(prev.activeFunds ?? []), curr],
                };
            }
            return {
                ...prev,
                disabledFunds: [...(prev.disabledFunds ?? []), { ...curr, isDisabled: true }],
            };
        }, []);
        setRowData([...activeFunds, ...disabledFunds]);
        setSelectedRows([...activeFunds, ...disabledFunds]);
    }, [props.portfolios]);

    const [callPanSeed, setCallPanSeed] = useState(false);

    const resetTrigger = () => {
        setCallPanSeed(false);
    }

    return (
        <div className="curved-bg">
            <PanSeedCheckNew
                foliosArray={selectedRows}
                callBackFn={() => {
                    props.userRegisteredWith === REGISTER_WITH_MOBILE
                        ? setShow(!show)
                        : handleSubmit();
                }}
                trxnType={NFT_TRXN_TYPE_MAP.changeMobile}
                triggerCheck={callPanSeed}
                resetTrigger={resetTrigger}
                goBack={false}
            />
            <ActionHeader header={dashboard.ChangeMobile.ChangeMobileHeading} />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <h5> {dashboard.ChangeMobile.ChangeMobileInfo}</h5>
                    <div className="curved-table-content">
                        <div className="curved-table-content-bottom" style={{ width: '100%' }}>
                            {!rowData.length && !loading ? (
                                <NoFoliosFound
                                    extraClass="consolidation-error"
                                    icon="error-red"
                                    info={'No Portfolios found'}
                                />
                            ) : (
                                <TableWithCollapse
                                    setSelectedRows={setSelectedRows}
                                    selectedRows={selectedRows}
                                    rows={tableRows}
                                    columns={tableColumns}
                                    isRowSelectable={() => false}
                                    toolTipTextGetter={({ row }) =>
                                        row.isDisabled
                                            ? dashboard.ChangeMobile.toolTipWithSameMobile
                                            : dashboard.ChangeMobile.toolTip
                                    }
                                    checkBoxEnabled
                                    toolTipEnabled
                                    isCheckBoxSelectable={false}
                                />
                            )}
                        </div>
                    </div>
                    <FaqLink section={UPDATE_MOBILE} history={props.history} />
                </div>
                {!!tableRows.length && (
                    <div className="curved-bg-content-inner-bottom">
                        <div className="table-submit">
                            <Button
                                onClick={() => setCallPanSeed(true)}
                                disabled={
                                    loading ||
                                    !selectedRows.filter((fund) => fund.mobile !== newMobile).length
                                }
                                className="customBtn"
                            >
                                {dashboard.ChangeMobile.buttonText}
                            </Button>
                        </div>
                    </div>
                )}
                <NoteModals
                    showModal={show}
                    heading={dashboard.noteModals.otpAuth.heading}
                    // mobileOrEmail={maskMobileNumber(props.mobile)}
                    info={`${dashboard.noteModals.otpAuth.subHeading} ${maskMobileNumber(
                        props.mobile,
                    )}. ${dashboard.noteModals.otpAuth.confirmText}`}
                    proceedBtn={dashboard.noteModals.otpModal.proceedText}
                    cancelBtn={dashboard.noteModals.otpModal.cancelText}
                    onProceed={handleSubmit}
                    onCancel={() =>
                        props.history.push('change-mobile-document', {
                            foliosToUpdate: selectedRows.filter(
                                (fund) => fund.mobile !== newMobile,
                            ),
                        })
                    }
                />
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { getPortfolio, sendPhoneOTP },
)(ChangeMobile);
